import { Link } from "react-router-dom";
import { H2, Image, SVG } from "../../AbstractElements";
import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
import {
  handleResponsiveToggle,
  setToggleSidebar,
} from "../../ReduxToolkit/Reducers/LayoutSlice";
import { dynamicImage } from "../../Service";
import { DashboardRoute, UserManagementRoute } from "../../utils/Constant";

const LogoWrapper = () => {
  const dispatch = useAppDispatch();
  const { toggleSidebar } = useAppSelector((state) => state.layout);
  const { sidebarIconType } = useAppSelector((state) => state.themeCustomizer);

  return (
    <>
      <div className="logo-wrapper">
        <Link to={`/${UserManagementRoute}`}>
          {/* <Image
            className="img-fluid"
            src={dynamicImage("logo/logo_light.png")}
            alt="logo"
          /> */}

          <H2 className="text-white d-flex align-items-center">IMS</H2>
        </Link>
        <div
          className="back-btn"
          onClick={() => dispatch(handleResponsiveToggle())}
        >
          <i className="fa fa-angle-left"></i>
        </div>
        <div className="toggle-sidebar">
          <SVG
            className={`${sidebarIconType}-icon sidebar-toggle status_toggle middle`}
            iconId={`${sidebarIconType === "fill" ? "fill-" : ""}toggle-icon`}
            onClick={() => dispatch(setToggleSidebar(!toggleSidebar))}
          />
        </div>
      </div>
      <div className="logo-icon-wrapper">
        <Link to={`/${UserManagementRoute}`}>
          <Image
            className="img-fluid"
            src={dynamicImage("logo/logo-icon.png")}
            alt="logo"
          />
        </Link>
      </div>
    </>
  );
};

export default LogoWrapper;
